import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema } from '../entities/inspection.js';
export const UpdateInspectionBodySchema = z.object({
    description: z.string().optional(),
    labels: z.array(z.string()).optional(),
});
export const UpdateInspectionApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: UpdateInspectionBodySchema,
    response: InspectionSchema,
};
export const UpdateInspectionRequestSchema = UpdateInspectionApiSchema.params
    .extend(UpdateInspectionApiSchema.body.shape)
    .extend(UpdateInspectionApiSchema.headers.shape);
